import React from 'react';
import { ExternalLink, Github, Twitter } from 'lucide-react';
export function Footer() {
  const resources = [{
    name: 'Blockchain.com',
    url: 'https://www.blockchain.com/explorer'
  }, {
    name: 'Blockchair',
    url: 'https://blockchair.com/bitcoin'
  }, {
    name: 'BitInfoCharts',
    url: 'https://bitinfocharts.com/bitcoin'
  }, {
    name: 'Glassnode',
    url: 'https://glassnode.com'
  }];
  return <footer className="bg-gray-900 border-t border-gray-800 mt-20" data-id="element-30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-31">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-32">
          {/* About */}
          <div data-id="element-33">
            <h3 className="text-white font-bold mb-4" data-id="element-34">About Top100Bitcoin</h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-35">
              A transparent, educational resource tracking the top 100 Bitcoin
              wallet addresses. All data is sourced from public blockchain
              explorers and updated regularly.
            </p>
          </div>

          {/* Resources */}
          <div data-id="element-36">
            <h3 className="text-white font-bold mb-4" data-id="element-37">Data Sources</h3>
            <ul className="space-y-2" data-id="element-38">
              {resources.map(resource => <li key={resource.name} data-id="element-39">
                  <a href={resource.url} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-orange-500 text-sm flex items-center gap-1 transition-colors" data-id="element-40">
                    {resource.name}
                    <ExternalLink className="w-3 h-3" data-id="element-41" />
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Disclaimer */}
          <div data-id="element-42">
            <h3 className="text-white font-bold mb-4" data-id="element-43">Disclaimer</h3>
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-44">
              This website is for educational purposes only. All data is
              publicly available on the Bitcoin blockchain. We do not claim
              ownership of any addresses or private information.
            </p>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-45">
          <p className="text-gray-500 text-sm" data-id="element-46">
            © 2025 Top100Bitcoin.com • Educational Resource
          </p>
          <div className="flex items-center gap-4" data-id="element-47">
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-orange-500 transition-colors" data-id="element-48">
              <Twitter className="w-5 h-5" data-id="element-49" />
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-orange-500 transition-colors" data-id="element-50">
              <Github className="w-5 h-5" data-id="element-51" />
            </a>
          </div>
        </div>
      </div>
    </footer>;
}